// 💵 A PART OF THE ADVANCE CANNOT BE MORE THAN THE ADVANCE (external review A-01, owner go-ahead
// 2026-09-16). The advance agreement prints a refund amount, a retention, a part held by senTavus and
// a part received by an agent — each a PORTION of `advance_amount` — and nothing stopped any of them
// exceeding it or being in another currency, so a signed document could promise to return more than
// was ever paid.
//
// ⚠️ ONLY CONTRADICTIONS. Silent when either figure is blank (the required-field gate speaks for
//    that). Each portion is bounded on its own; whether two portions may together exceed the advance
//    is a question of which outcome applies, and they belong to different outcomes.
// ⚠️ MIRRORED on the server (lib/advance_amounts.js) — the form warns, the API refuses; both are
//    pinned by tests on the same cases.
export const ADVANCE_PARTS = ['refund_amount', 'payer_fault_retention', 'part_held_by_agency', 'agent_received_amount']

const money = v => (v && typeof v === 'object' && v.value !== '' && v.value != null && Number.isFinite(Number(v.value)) ? { value: Number(v.value), currency: v.currency || '' } : null)

// 💬 A SMALLER REFUND NAMES ITS REASON (owner 2026-09-17: "auto fill full amount but everything
// happens leave the room"). The owner-fault refund fills in as the whole advance; the agent may lower
// it, and then must say why — the reason is printed (clause 4c4, migration 1255). A reason with a
// full refund would print "less than the whole advance" over a full return, so that is refused too.
/** True when the owner-fault refund is set, in the advance's currency, and below the advance. */
export function refundReduced(values) {
  const adv = money(values?.advance_amount), refund = money(values?.refund_amount)
  return !!(adv && refund && (!refund.currency || !adv.currency || refund.currency === adv.currency) && refund.value < adv.value)
}

/** Which portion fields contradict the advance → Map(fieldKey → message key). */
export function advanceAmountProblems(values) {
  const bad = new Map()
  const adv = money(values?.advance_amount)
  if (!adv) return bad
  for (const k of ADVANCE_PARTS) {
    const part = money(values?.[k])
    if (!part) continue
    if (part.currency && adv.currency && part.currency !== adv.currency) bad.set(k, 'amount_currency_differs_from_advance')
    else if (part.value < 0) bad.set(k, 'amount_negative')
    else if (part.value > adv.value) bad.set(k, 'amount_exceeds_advance')
  }
  const reason = String(values?.refund_reduction_reason || '').trim()
  if (!bad.has('refund_amount')) {
    if (refundReduced(values) && !reason) bad.set('refund_reduction_reason', 'reason_required_for_smaller_refund')
    else if (!refundReduced(values) && reason) bad.set('refund_reduction_reason', 'reason_without_smaller_refund')
  }
  return bad
}
